import React, { useState ,useEffect} from 'react'
import { Link, useLocation } from 'react-router-dom'
import StudyImage from "../../../src/assets/Logo/Logo-Full-Light.png"
import {NavbarLinks} from "../../../src/data/navbar-links"
import { useSelector } from 'react-redux'
import {AiOutlineShoppingCart} from "react-icons/ai"
import ProfileDropDown from '../core/Auth/ProfileDropDown'
import { apiConnector } from '../../../src/services/apiconnector'
import { categories } from '../../../src/services/api'
import {IoIosArrowDropdownCircle} from "react-icons/io"
import {BsChevronDown} from "react-icons/bs"
// const subLinks=[
//    {
//     title:"python",
//     link:"catalog/python"
//    },
//    {
//     title:"web dev",
//     link:"catalog/web-development"
//    }
// ]


const Navbar = () => {

    const {token}=useSelector((state)=>state.auth);
    const {user}=useSelector((state)=>state.profile);
    const {totalItems}=useSelector((state)=>state.cart);
    const[loading,setloading]=useState(false);   
     const location=useLocation();

    const [subLinks,setsubLink]=useState([]);
   
     const fetchSubLink=async()=>{
       try{
        const result= await apiConnector("GET",categories.CATEGORIES_API);
        console.log("result",result)
         setsubLink(result.data.data);
         } catch(error)
         {
           console.log("could not fetch catalog list",error.message);
         }
     }
  
     useEffect(() => {
           fetchSubLink();
     }, [])
     
  console.log("sublink",subLinks)

    const matchRoutes=(route)=>{
       
           return route===location.pathname;
    }

  return (
    <div className='flex flex-row h-14 items-center justify-center border-b-[1px] border-b-richblack-700 bg-richblack-800'>
      
         <div className='w-11/12 max-w-maxContent items-center justify-between flex'>

             {/*image*/}
             
             <Link to={"/"}>
               <img src={StudyImage} width={160} height={42} loading='lazy'></img>
             </Link>
           
           {/*nav items*/}

             <nav>
                <ul className='flex gap-x-6 text-richblack-25'>
              
                   { 
                    NavbarLinks.map((link,index)=>(
                        <li key={index}>
                        {link.title === "Catalog" ? (
                        <>
                          <div
                            className={`group relative flex cursor-pointer items-center gap-1 ${
                              matchRoutes("/catalog/:catalogName")
                                ? "text-yellow-25"
                                : "text-richblack-25"
                            }`}
                          >
                            <p>{link.title}</p>
                            <BsChevronDown />
                            <div className="invisible absolute left-[50%] top-[50%] z-[1000] flex w-[200px] translate-x-[-50%] translate-y-[3em] flex-col rounded-lg bg-richblack-5 p-4 text-richblack-900 opacity-0 transition-all duration-150 group-hover:visible group-hover:translate-y-[1.65em] group-hover:opacity-100 lg:w-[300px]">
                              <div className="absolute left-[50%] top-0 -z-10 h-6 w-6 translate-x-[80%] translate-y-[-40%] rotate-45 select-none rounded bg-richblack-5"></div>
                              {loading ? (
                                <p className="text-center">Loading...</p>
                              ) : subLinks?.length ? (
                                <>
                                  {subLinks
                                  
                                    ?.map((subLink, i) => (
                                      <Link
                                        to={`/catalog/${subLink.name
                                          .split(" ")
                                          .join("-")
                                          .toLowerCase()}`}
                                        className="rounded-lg bg-transparent py-4 pl-4 hover:bg-richblack-50"
                                        key={i}
                                      >
                                        <p>{subLink.name}</p>
                                      </Link>
                                    ))}
                                </>
                              ) : (
                                <p className="text-center">No Courses Found</p>
                              )}
                            </div>
                          </div>
                        </>
                      )  : (
                                <Link to={link.path}>
                                <p className={`${matchRoutes(link?.path) ? "text-yellow-25" :
                                "text-richblack-25"}`}>
                                       {link?.title}
                                       
                                </p>
                                
                                </Link>
                              )}
                        </li>
                    ))
                   }
                
                </ul>
             </nav>

             {/*login signup dashboard*/}

             <div className='flex gap-x-4 items-center'>
                    {
                      user && user?.accountType != "Instructor" && (
                        <Link to="/dashboard/cart" className='relative'>
                           <AiOutlineShoppingCart className='text-2xl text-richblack-100 '/>
                           {
                            totalItems>0 && (
                              <span  className="absolute -bottom-2 -right-2 grid h-5 w-5 place-items-center overflow-hidden rounded-full bg-richblack-600 text-center text-xs font-bold text-yellow-100">
                                {totalItems}
                              </span>
                           )
                           }
                        </Link>
                      )
                    }
                    {
                      token===null && (
                        <Link to="/login">
                          <button className='border border-richblack-700 bg-richblack-800 
                          p-[8px] text-richblack-100 rounded-md'>
                            Log in
                          </button>
                        </Link>
                      )
                    }
                    {
                      token===null && (
                        <Link to="/signup">
                          <button className='border border-richblack-700 bg-richblack-800 
                          p-[8px] text-richblack-100 rounded-md'>
                            Sign Up
                          </button>
                        </Link>
                      )
                    }
                    {
                      token !==null && ( <ProfileDropDown/>
                      )
                    }
             </div>  
              
              
         </div>

    </div>
  )
}

export default Navbar